import React, { useState } from 'react';
import { Form, Input, Button, Typography, Card, message } from 'antd';
import { UserOutlined, MailOutlined, LockOutlined, ShopOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { scrollToFirstError } from '../utils/formHelpers';

const { Title, Text } = Typography;

const Register = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const validatedValues = await form.validateFields();
      setLoading(true);
      // TODO: اینجا باید API call انجام شود
      // const response = await fetch('/api/auth/register', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(values),
      // });
      // const data = await response.json();
      
      // شبیه‌سازی ثبت نام
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      message.success('ثبت نام با موفقیت انجام شد');
      // هدایت به صفحه لاگین
      navigate('/login');
    } catch (error) {
      if (error.errorFields && error.errorFields.length > 0) {
        scrollToFirstError(form);
      } else {
        message.error('خطا در ثبت نام. لطفاً دوباره تلاش کنید');
      }
    } finally {
      setLoading(false);
    }
  };

  // مسیر تصویر بکگراند
  const backgroundImage = `${process.env.PUBLIC_URL || ''}/images/bg_image.webp`;

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 relative"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: isDarkMode ? '#1a1a1a' : '#f0f0f0',
      }}
    >
      {/* لایه تیره برای خوانایی بهتر */}
      <div className="absolute inset-0 bg-black/40 dark:bg-black/60"></div>

      {/* محتوای اصلی */}
      <div className="relative z-10 w-full max-w-md">
        <Card
          className={`rounded-2xl shadow-2xl border-0 overflow-hidden ${
            isDarkMode 
              ? 'bg-gray-800/95 backdrop-blur-md' 
              : 'bg-white/95 backdrop-blur-md'
          }`}
          bodyStyle={{ padding: '3rem' }}
        >
          {/* عنوان */}
          <div className="text-center mb-8">
            <Title 
              level={2} 
              className={`!mb-2 !font-bold ${
                isDarkMode ? 'text-white' : 'text-gray-800'
              }`}
              style={{ fontFamily: 'CustomFont' }}
            >
              ثبت نام
            </Title>
            <Text 
              className={`text-base ${
                isDarkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
              style={{ fontFamily: 'CustomFont' }}
            >
              حساب کاربری جدید ایجاد کنید
            </Text>
          </div>

          {/* فرم ثبت نام */}
          <Form
            form={form}
            name="register"
            onFinish={onFinish}
            layout="vertical"
            size="middle"
            className="mt-8"
          >
            <Form.Item
              name="companyName"
              rules={[
                { required: true, message: 'لطفاً نام شرکت را وارد کنید' },
              ]}
              className="mb-5"
            >
              <Input
                prefix={<ShopOutlined className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`} />}
                placeholder="نام شرکت"
                className={`h-12 rounded-lg border-2 transition-all ${
                  isDarkMode 
                    ? 'bg-gray-700/50 border-gray-600 text-white focus:border-blue-500' 
                    : 'bg-gray-50 border-gray-200 text-gray-800 focus:border-blue-500'
                }`}
                style={{ fontFamily: 'CustomFont' }}
              />
            </Form.Item>

            <Form.Item
              name="fullName"
              rules={[
                { required: true, message: 'لطفاً نام خود را وارد کنید' },
              ]}
              className="mb-5"
            >
              <Input
                prefix={<UserOutlined className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`} />}
                placeholder="نام شما"
                className={`h-12 rounded-lg border-2 transition-all ${
                  isDarkMode 
                    ? 'bg-gray-700/50 border-gray-600 text-white focus:border-blue-500' 
                    : 'bg-gray-50 border-gray-200 text-gray-800 focus:border-blue-500'
                }`}
                style={{ fontFamily: 'CustomFont' }}
              />
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'لطفاً آدرس ایمیل را وارد کنید' },
                { type: 'email', message: 'لطفاً یک ایمیل معتبر وارد کنید' },
              ]}
              className="mb-5"
            >
              <Input
                prefix={<MailOutlined className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`} />}
                placeholder="آدرس ایمیل"
                className={`h-12 rounded-lg border-2 transition-all ${
                  isDarkMode 
                    ? 'bg-gray-700/50 border-gray-600 text-white focus:border-blue-500' 
                    : 'bg-gray-50 border-gray-200 text-gray-800 focus:border-blue-500'
                }`}
                style={{ fontFamily: 'CustomFont' }}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                { required: true, message: 'لطفاً رمز عبور را وارد کنید' },
                { min: 6, message: 'رمز عبور باید حداقل ۶ کاراکتر باشد' },
              ]}
              className="mb-6"
            >
              <Input.Password
                prefix={<LockOutlined className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`} />}
                placeholder="رمز عبور"
                className={`h-12 rounded-lg border-2 transition-all ${
                  isDarkMode 
                    ? 'bg-gray-700/50 border-gray-600 text-white focus:border-blue-500' 
                    : 'bg-gray-50 border-gray-200 text-gray-800 focus:border-blue-500'
                }`}
                style={{ fontFamily: 'CustomFont' }}
              />
            </Form.Item>

            <Form.Item className="mb-4">
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                className="h-12 rounded-lg text-base font-semibold shadow-lg hover:shadow-xl transition-all"
                style={{ 
                  fontFamily: 'CustomFont',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                }}
              >
                {loading ? 'در حال ثبت نام...' : 'ثبت نام'}
              </Button>
            </Form.Item>
          </Form>

          {/* لینک بازگشت به لاگین */}
          <div className="text-center mt-6">
            <Text 
              className={`text-sm ${
                isDarkMode ? 'text-gray-400' : 'text-gray-600'
              }`}
              style={{ fontFamily: 'CustomFont' }}
            >
              حساب کاربری دارید؟{' '}
              <Link
                to="/login"
                className={`
                  ${isDarkMode 
                    ? 'text-blue-400 hover:text-blue-300' 
                    : 'text-blue-600 hover:text-blue-700'
                  }
                  transition-colors font-semibold
                `}
                style={{ fontFamily: 'CustomFont' }}
              >
                ورود
              </Link>
            </Text>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Register;

